import request from '@/utils/request'
export function getExpressDetail (val, phone) {
	return request({
		url: `/api/pub/open/express/track/${val.shipperCode}/${val.trackNo}`,
		method: 'get',
		params: {
			customerName: phone
		},
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}

// 后台售后管理----------------------------------------------------------
// 查询售后列表
export function postsalePage (val) {
	return request({
		url: '/api/oms/admin/postsale/page',
		method: 'post',
		data: val.vo,
		params: val.params
	})
}

// 售后管理类型-----------------------------------------------------
// 新增售后类型
export function postsaleType (val) {
	return request({
		url: '/api/oms/postsale/type',
		method: 'post',
		data: val
	})
}

// 查询售后类型
export function postsaleTypeList (val) {
	return request({
		url: '/api/oms/postsale/type/list',
		method: 'get',
		params: val,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 修改售后类型
export function postsaleTypeEdit (val) {
	return request({
		url: `/api/oms/postsale/type/${val.postsaleTypeId}`,
		method: 'post',
		data: val.data
	})
}
// 启用-禁用
export function postsaleTypeChangeEnabled (val) {
	return request({
		url: `/api/oms/postsale/type/${val.postsaleTypeId}/${val.enabled}`,
		method: 'put',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}

// 后台管理订单--------------------------------------------------------
// 订单结算-申请
export function settlementApply (val) {
	return request({
		url: '/api/oms/admin/settlement',
		method: 'post',
		data: val.data
	})
}
// 订单结算-待结算列表
export function settlementListOrder (val) {
	return request({
		url: '/api/oms/admin/settlement/list',
		method: 'post',
		data: val.data
	})
}
// 查询订单列表
export function order (val) {
	return request({
		url: '/api/oms/admin/order/page',
		method: 'post',
		data: val.vo,
		params: {
			page: val.page,
			size: val.size,
			sort: 'dateSubmitted,desc'
		}
	})
}

// 拓客订单结算
export function settlementOrder (val) {
	return request({
		url: '/api/oms/admin/settlement/page',
		method: 'post',
		data: val.vo,
		params: {
			page: val.page,
			size: val.size
		}
	})
}
// 拓客订单批量审核
export function settlementBatchAudit (val, data) {
	return request({
		url: `/api/oms/admin/settlement/${val.auditStatus}`,
		method: 'put',
		data: data,
		headers: {
			'Content-Type': 'application/json'
		}
	})
}
// 订单详情列表
export function getSettlement (val) {
	return request({
		url: `/api/oms/admin/settlement/get/${val}`,
		method: 'get',
		params: val,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 订单结算-审核
export function settlementAudit (val) {
	return request({
		url: `/api/oms/admin/settlement/${val}`,
		method: 'put',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}

// 根据订单状态获取订单数量
export function orderCount (val) {
	return request({
		url: '/api/oms/admin/order/statistic/count',
		method: 'get',
		params: val,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 订单导出
export function orderExport (val) {
	return request({
		url: '/api/oms/admin/order/export',
		method: 'post',
		data: val,
		responseType: 'blob'
	})
}
// 拓客订单结算导出
export function settlementOrderExport (val) {
	return request({
		url: '/api/oms/admin/settlement/export',
		method: 'post',
		data: val,
		responseType: 'blob'
	})
}
// 获取订单来源统计
export function orderOriginStatistic (val) {
	return request({
		url: '/api/oms/admin/order/statistic/origin',
		method: 'get',
		params: val,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 获取订单支付类型统计
export function orderPaymentTypeStatistic (val) {
	return request({
		url: '/api/oms/admin/order/statistic/paymentType',
		method: 'get',
		params: val,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 获取订单数量统计
export function orderQuantityStatistic (val) {
	return request({
		url: '/api/oms/admin/order/statistic/quantity',
		method: 'get',
		params: val,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 获取订单数量统计翻页
export function orderQuantityStatisticPage (val) {
	return request({
		url: '/api/oms/admin/order/statistic/quantity/page',
		method: 'get',
		params: val,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 产品分类销售统计
export function orderSpuCategorySaleStatistic (val) {
	return request({
		url: '/api/oms/admin/order/statistic/spuCategorySale',
		method: 'get',
		params: val,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 产品销售总量统计
export function orderSpuSaleCountStatistic (val) {
	return request({
		url: '/api/oms/admin/order/statistic/spuSale/count',
		method: 'get',
		params: val,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 产品销售统计
export function orderSpuSaleStatistic (val) {
	return request({
		url: '/api/oms/admin/order/statistic/spuSale',
		method: 'get',
		params: val,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 按订单ID查找订单详情
export function adminOrder (val) {
	return request({
		url: `/api/oms/admin/order/${val}`, // 接口
		method: 'get', // 请求方式
		params: val,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 店铺产品销售统计
export function orderStore (val) {
	return request({
		url: '/api/oms/admin/order/statistic/store/spuSale',
		method: 'get',
		params: val.params,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 查询订单流转记录
export function orderLogList (val) {
	return request({
		url: `/api/oms/admin/order/${val}/log/list`,
		method: 'get',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 后台订单任务-----------------------------------------------------------------
// 查询任务列表
export function orderTaskPage (val) {
	return request({
		url: '/api/oms/admin/order/task/page',
		method: 'post',
		params: val.params,
		data: val.data
	})
}
// 导出
export function taskExport (val) {
	return request({
		url: '/api/oms/admin/order/task/export',
		method: 'post',
		data: val,
		responseType: 'blob'
	})
}
// 导出对账单
export function statementExport (val) {
	return request({
		url: '/api/oms/admin/order/task/statementExport',
		method: 'post',
		data: val,
		responseType: 'blob'
	})
}
// 查询任务快递
export function orderTaskExpress (val) {
	return request({
		url: `/api/oms/admin/order/task/express/${val}`,
		method: 'post',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 查询任务流转记录
export function taskLogList (val) {
	return request({
		url: `/api/oms/admin/order/task/${val}/log/list`,
		method: 'get',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 后台订单改价--------------------------------------------------------
// 订单特价申请翻页
export function orderDiscountPage (val) {
	return request({
		url: '/api/oms/admin/order/discount/page',
		method: 'post',
		params: val.params,
		data: val.data
	})
}
// 导出
export function discountExport (val) {
	return request({
		url: '/api/oms/admin/order/discount/export',
		method: 'post',
		data: val,
		/* headers: {
			'Content-Type': 'application/msexcel'
		}, */
		responseType: 'blob'
	})
}
export function getOrderStatusLogs (val) {
	return request({
		url: `/api/oms/admin/order/${val}/log/list`,
		method: 'get',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 取消订单
export function adminOrderCancel (val) {
	return request({
		url: `/api/oms/order/${val}/cancel`, // 接口
		method: 'put', // 请求方式
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
export function orderPriceApply (val) {
	return request({
		url: `/api/oms/admin/order/discount/apply/${val.orderNo}`,
		method: 'post',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		params: {
			discountPrice: val.discountPrice
		}
	})
}
export function changeSuborderMessage (val) {
	return request({
		url: `/api/oms/admin/order/suborder/${val.subOrderId}/message`,
		method: 'put',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		params: {
			message: val.message
		}
	})
}
export function getRenderPdf (val) {
	return request({
		url: `/api/ots/open/orderItem/getRenderInfoByOutOrderItemNo/${val}`,
		method: 'get',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
export function auditDiscount (val) {
	return request({
		url: `/api/oms/admin/order/discount/audit/${val.auditStatus}/${val.orderId}`,
		method: 'put',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		params: {
			originType: 'WEB',
			orderPayChannel: val.type
		}
	})
}
// 修改子订单发货地址
export function suborderAddress (val) {
	return request({
		url: `/api/oms/admin/order/suborder/${val.suborderId}/address`, // 接口
		method: 'put', // 请求方式
		params: val.params,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 查询订单明细详情
export function orderSuborderInfo (id) {
	return request({
		url: `/api/oms/order/suborder/${id}`, // 接口
		method: 'get', // 请求方式
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 立即提交订单
export function orderNow (val) {
	return request({
		url: '/api/oms/order/sample', // 接口
		method: 'post', // 请求方式
		data: val
	})
}
// 查询第三方订单号
export function getByOutOrderNo (id) {
	return request({
		url: `/api/oms/order/getByOutOrderNo/${id}`, // 接口
		method: 'get', // 请求方式
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
// 查询第三方订单号
export function getUrgentOrderNo (id) {
	return request({
		url: `/api/oms/order/urgent/${id}`, // 接口
		method: 'put', // 请求方式
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
